import ModulePagination from './ModulePagination';

export default ModulePagination;
export * from './ModulePagination';
